/*
 *
 * Example of Usage:
 *
 * 1 - Simple usage
 *    <Tooltip title="Tooltip message"> Button </Tooltip>
 *
 * 2 - Component with placement
 *    <Tooltip top title="Tooltip message"> Button </Tooltip>
 *    <Tooltip right title="Tooltip message"> Button </Tooltip>
 *    <Tooltip bottom title="Tooltip message"> Button </Tooltip>
 *    <Tooltip left title="Tooltip message"> Button </Tooltip>
 *
 ****Note: You can"t use two placements at the same time****
 *
 * 3 - Static Tooltip (Always Shown until text is empty)
 *    <Tooltip static> Button </Tooltip>
 *
 * 4 - Colored Tooltip (Current Colors: Green)
 *    <Tooltip color="green"> Button <Tooltip>
 *
 ****Note: If the "title" property is not given, the tooltip won't appear.
 */

"use strict";

var cx = require("classnames");

var Tooltip = React.createClass({
  propTypes: {
    title: React.PropTypes.string,
    html: React.PropTypes.bool,
    top: React.PropTypes.bool,
    left: React.PropTypes.bool,
    right: React.PropTypes.bool,
    bottom: React.PropTypes.bool,
    static: React.PropTypes.bool,
    color: React.PropTypes.oneOf(["default", "green", "darker"]),
    container: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.bool]),
    trigger: React.PropTypes.string,
    block: React.PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      color: "default",
      trigger: "hover focus",
      container: false,
      html: false,
      block: false
    };
  },

  componentDidMount: function() {
    this.toggleTooltip();
  },

  shouldComponentUpdate: function(nextProps, nextState) {
    return nextProps.title !== this.props.title ||
           nextProps.children != this.props.children;
  },

  componentDidUpdate: function() {
    this.toggleTooltip();
  },

  toggleTooltip: function() {
    if(this.props.title){
      if(this.props.static){
        $(this.tooltipElem).tooltip({trigger: "manual"}).tooltip("show");
      } else {
        $(this.tooltipElem).tooltip();
      }
    } else {
      $(this.tooltipElem).tooltip("destroy");
    }
  },

  show: function(callback) {
    $(this.tooltipElem).tooltip("show");

    if (callback) {
      callback();
    }
  },

  hide: function() {
    $(this.tooltipElem).tooltip("hide");
  },

  getTooltipPlacement: function() {
    var tooltipPlacement = cx({
      "top": this.props.top,
      "left": this.props.left,
      "right": this.props.right,
      "bottom": this.props.bottom
    });
    if (tooltipPlacement == "") {
      var defaultPlacement = "top";
    };

    return tooltipPlacement || defaultPlacement;
  },

  getTooltipClassByColor: function(color) {
    var tooltipColorClasses = {
      "green": "tooltip--green",
      "darker": "tooltip--darker"
    };
    return tooltipColorClasses[color];
  },

  render: function(){
    var displayClass = this.props.block ? "d-b" : "d-ib";

    return (
      <span className={cx(this.getTooltipClassByColor(this.props.color), displayClass)}>
        <span
          className={displayClass} ref={tooltipElem => this.tooltipElem = tooltipElem}
          data-toggle="tooltip" data-placement={this.getTooltipPlacement()}
          data-original-title={this.props.title} data-trigger={this.props.trigger}
          data-container={this.props.container} data-html={this.props.html}
        >
          {this.props.children}
        </span>
      </span>
    );
  }
});

module.exports = Tooltip;



// WEBPACK FOOTER //
// ./app/shared/components/Tooltip/tooltip.jsx